import { sub } from 'date-fns';

export const RangeShortcut = {
  today: 'TODAY',
  yesterday: 'YESTERDAY',
  last3Days: 'LAST_3_DAYS',
  last7Days: 'LAST_7_DAYS',
  last14Days: 'LAST_14_DAYS',
  last30Days: 'LAST_30_DAYS',
  reset: "RESET"
};

export const rangeShortcuts = [
  // {
  //   id: 'common.sendDate.today',
  //   range: RangeShortcut.today,
  //   name: '今天',
  // },
  // {
  //   id: 'common.sendDate.yesterday',
  //   range: RangeShortcut.yesterday,
  //   name: '昨天',
  // },
  {
    id: 'common.sendDate.last3Days',
    range: RangeShortcut.last3Days,
    name: '過去3天',
  },
  {
    id: 'common.sendDate.last7Days',
    range: RangeShortcut.last7Days,
    name: '過去7天',
  },
  {
    id: 'common.sendDate.last14Days',
    range: RangeShortcut.last14Days,
    name: '過去14天',
  },
  {
    id: 'common.sendDate.last30Days',
    range: RangeShortcut.last30Days,
    name: '過去30天',
  },
  {
    id: 'common.sendDate.custom',
    range: RangeShortcut.reset,
    name: '重設',
  }
];

export const updateDateRangeByShortcut = (range) => {
  switch (range) {
    case RangeShortcut.today:
      return {
        startReportDate: sub(new Date(), { days: 0 }),
        endReportDate: sub(new Date(), { days: 0 })
      };
    case RangeShortcut.yesterday:
      return {
        startReportDate: sub(new Date(), { days: 1 }),
        endReportDate: sub(new Date(), { days: 1 })
      }
    case RangeShortcut.last3Days:
      return {
        startReportDate: sub(new Date(), { days: 3 }),
        endReportDate: sub(new Date(), { days: 1 })
      }
    case RangeShortcut.last7Days:
      return {
        startReportDate: sub(new Date(), { days: 7 }),
        endReportDate: sub(new Date(), { days: 1 })
      }
    case RangeShortcut.last14Days:
      return {
        startReportDate: sub(new Date(), { days: 14 }),
        endReportDate: sub(new Date(), { days: 1 })
      }
    case RangeShortcut.last30Days:
      return {
        startReportDate: sub(new Date(), { days: 30 }),
        endReportDate: sub(new Date(), { days: 1 })
      }
    case RangeShortcut.reset:
      return {
        startReportDate: null,
        endReportDate: null
      }
    default:
      return {
        startReportDate: null,
        endReportDate: null
      };
  }
};